import React from "react";
import { CustomTextField } from "../formsComponents";
import { SxProps, TextFieldProps } from "@mui/material";
import { Theme } from "@emotion/react";

interface IPhoneTextProps {
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
  value: any;
  id?: TextFieldProps["id"];
  name?: TextFieldProps["name"];
  label?: TextFieldProps["label"];
  variant?: TextFieldProps["variant"];
  size?: TextFieldProps["size"];
  error?: TextFieldProps["error"];
  helperText?: TextFieldProps["helperText"];
  disabled?: boolean;
  onChange?: (newValue: string) => void;

  setFieldValue?: (field: string, value: any) => void;
  InputProps?: TextFieldProps["InputProps"];
  placeholder?: TextFieldProps["placeholder"];
  highlight?: boolean;
}

export const PhoneTextField: React.FC<IPhoneTextProps> = (props) => {
  const {
    value,
    fullWidth = true,
    sx,
    onChange,

    error,
    helperText,
    id,
    name,
    label,
    variant,
    size,
    disabled,
    setFieldValue,
    InputProps,
    placeholder = "Enter contact number",
    highlight
  } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.toString();

    value = value.replace(/\D/g, "");

    if (value.startsWith("0")) {
      value = value.replace(/^0+/, "");
    }

    if (!value || value.length < 15) {
      if (onChange) {
        onChange(value);
      } else if (setFieldValue) {
        setFieldValue(id ? id : name ? name : "", value);
      }
    }
  };

  return (
    <CustomTextField
      highlight={highlight}
      fullWidth={fullWidth}
      InputLabelProps={{
        shrink: true,
      }}
      inputMode="numeric"
      placeholder={placeholder}
      sx={sx}
      id={id}
      name={name}
      label={label}
      variant={variant}
      size={size}
      value={value}
      error={error}
      helperText={helperText}
      disabled={disabled}
      onChange={handleChange}
      InputProps={InputProps}
      inputProps={{
        inputMode: "numeric", // ← mobile numeric keyboard
        pattern: "[0-9]*", // ← allow only digits
      }}
    />
  );
};
